// ** Third Party Components
import styled, { css } from "styled-components";

// ** Styles Import
import { breakpoints } from "styles/grid";

// #####################################################

export const StyledInput = styled("input")`
	color: ${({ theme: { colors } }) => colors.black};

	@media (max-width: ${breakpoints.phone - 1}px) {
		width: 100%;
	}

	${({ isSelected }) =>
		isSelected &&
		css`
			font-weight: bold;
		`}
`;

export const AutocompleteInput = ({ innerRef, ...props }) => (
	<StyledInput {...props} ref={innerRef} />
);

// #####################################################
